import React from "react";
import "./preloader.scss";

const Preloader = ({ type }) =>
  type === "inline" ? (
    <section className='preloader-inline'>
      <div className='content'>
        <div className='loading'>
          <span></span>
        </div>
      </div>
    </section>
  ) : (
    <section className='preloader'></section>
  );

export default Preloader;
